import {
  NurseIcon,
  RunningIcon,
  DoctorIcon,
  CommentsIcon,
  HelpingIcon,
  MedicalNotesIcon,
  BriefcaseIcon,
} from "../../Icons";
import { POSITION_NAMES } from "./evaluation.constants";
import {
  EVALUATION_MODULE_EXCLUDED_ROLES,
  normalizeRoleCode,
} from "../../constants";

export const getRoleIcon = (role) => {
  // Normalize role string for comparison
  const normalizedRole = role ? role.toUpperCase().replace("-", " ") : "";

  switch (normalizedRole) {
    case "RN":
      return NurseIcon;
    case "PT":
      return RunningIcon;
    case "PTA":
      return RunningIcon;
    case "OT":
      return DoctorIcon;
    case "OTA":
      return DoctorIcon;
    case "ST":
      return CommentsIcon;
    case "HHA":
      return MedicalNotesIcon;
    case "LVN":
      return NurseIcon;
    case "MSW":
      return HelpingIcon;
    case "OFFICE ASSISTANT":
    case "OA":
      return BriefcaseIcon;
    default:
      return DoctorIcon;
  }
};

export const getRoleOptions = () => {
  return Object.entries(POSITION_NAMES)
    .filter(([key]) => {
      if (key === "admin" || key === "oa") return false;
      const code = normalizeRoleCode(key);
      return !EVALUATION_MODULE_EXCLUDED_ROLES.includes(code);
    })
    .map(([key, label]) => {
      const value = key === "office-assistant" ? "OA" : key.toUpperCase();

      return {
        value: value,
        label: label,
        icon: getRoleIcon(value),
      };
    });
};
